import React from 'react'
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import moment from 'moment'
import { APIGetLoggerSummaryModel } from "models/APIGetLoggerSummaryModel";
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
interface Props {
    deviceData: APIGetLoggerSummaryModel | undefined
}


const DeviceSummaryMobile: React.FC<Props> = ({deviceData }) => {
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    const intl: IntlShape = useIntl()
    const p = {
        fontSize: "18px"
    }
    return (
        <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ textAlign: "center", width: "100%", display: (isLandscape || isTablet) ? 'flex' : 'block', justifyContent: (isLandscape || isTablet) ? 'space-evenly' : 'inherit' }}>
                    <div>
                        <h3 ><b><FormattedMessage id='Details' /></b></h3>
                        <p style={p}>{`${window.location.hostname.includes('zonelog.net') ? 'ZONELOG: ' : 'CharIOT: '}`}<b>{`${deviceData?.Model}`}</b></p>
                        <p style={p}><FormattedMessage id='Firmware Version'/>: <b>{`${deviceData?.Swversion}`}</b></p>
                        <p style={p}><FormattedMessage id='Last Connected'/>: <b>{`${moment(deviceData?.LastConnected).format('DD MMM YYYY HH:mm:ss')}`}</b></p>
                        <p style={p}><FormattedMessage id='Last Data Received'/>: <b>{`${moment(deviceData?.LastReading).format('DD MMM YYYY HH:mm:ss')}`}</b></p>
                        <p style={p}><FormattedMessage id='Device Name'/>: <b>{`${deviceData?.SiteId}`}</b></p>
                        <p style={p}><FormattedMessage id='Site'/>: <b>{`${deviceData?.SiteName && deviceData?.SiteName.length > 20 ? deviceData?.SiteName.slice(0, 20) + '...' : deviceData?.SiteName}`}</b></p>
                        <p style={p}><FormattedMessage id='GPS'/>: <b>{deviceData?.GpsLatitude && deviceData?.GpsLongitude ? `Lat: ${deviceData?.GpsLatitude} Lng: ${deviceData?.GpsLongitude}` : 'Not Set'}</b></p>
                    </div>
                    {(!isLandscape && !isTablet) && <hr style={{ background: "gray", margin: "30px 0" }} />}
                    <div>
                        <h3 ><b><FormattedMessage id='Connection / Stats'/></b></h3>
                        <p style={p}><FormattedMessage id='Battery'/> (V): <b>{deviceData?.ReadBatteryChannel ? `${deviceData?.ReadBatteryChannel / 1000}` : 'Not Available'}</b></p>
                        <p style={p}><FormattedMessage id='Signal'/>: <b>{deviceData?.LatestRssi ?`${deviceData?.LatestRssi}` : 'Not Available'}</b></p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DeviceSummaryMobile